var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTablet1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.75,68V12A2.7528,2.7528,0,0,0,66,9.25H26A2.7528,2.7528,0,0,0,23.25,12V68A2.7528,2.7528,0,0,0,26,70.75H66A2.7528,2.7528,0,0,0,68.75,68Zm-1.5,0A1.25116,1.25116,0,0,1,66,69.25H26A1.25116,1.25116,0,0,1,24.75,68V12A1.25116,1.25116,0,0,1,26,10.75H66A1.25116,1.25116,0,0,1,67.25,12Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 15.25,
    width: 6,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46,61.25A2.75,2.75,0,1,0,48.75,64,2.7528,2.7528,0,0,0,46,61.25Zm0,4A1.25,1.25,0,1,1,47.25,64,1.25116,1.25116,0,0,1,46,65.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9.25a.74994.74994,0,0,0-.71143.5127l-2,6A.75482.75482,0,0,0,11.25,16V68a2.75,2.75,0,0,0,5.5,0V16a.75482.75482,0,0,0-.03857-.2373l-2-6A.74994.74994,0,0,0,14,9.25ZM15.25,68a1.25,1.25,0,0,1-2.5,0V16.12158l1.25-3.75,1.25,3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablet1);
export default __webpack_public_path__ + "static/media/icon_tablet_1.b2b56fbcb82acdbc72c93a2388554764.svg";
export { ForwardRef as ReactComponent };